S.stickybuttons = {
    config: {},

    elements: {
        $top: null,
    },

    init()
    {
        this.showTopButton();
        this.initTopButton();
    },

    showTopButton()
    {
        if ($(window).scrollTop() > $('.l-header').height())
        {
            // console.log($(window).scrollTop());
            this.elements.$top.addClass('is-show');
        }
        else
        {
            this.elements.$top.removeClass('is-show');
        }
    },

    initTopButton()
    {
        this.elements.$top.on('click', () =>
        {
            location.href = '#top';
        });

        $(window).scroll(() =>
        {
            // $(window).height()
            S.delayed('showTopButton', 50, () =>
            {
                this.showTopButton();
            });
        });
    },
};
